import * as React from 'react';
import {PopoverButton, TscPopoverOrigin, TscButtonType, TscButtonGlyphPlacement, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';
import VersionsMenuContainer from '../VersionsMenu/VersionsMenuContainer';
import ReviewVersionModel from '../../types/ReviewVersionModel';

export default ({themeName, currentVersionNumber, deleteVersion}: VersionsButtonProps) => {
   const popoverProps = {
      buttonType: TscButtonType.secondary,
      origin: TscPopoverOrigin.bottomLeft,
      popoverMenu: <VersionsMenuContainer deleteVersion={deleteVersion}/>,
      themeName: themeName,
      showArrow: false,
      buttonTitle: Strings.labels.versions.versionsMenuTitle,
      glyphPlacement: TscButtonGlyphPlacement.right,
      buttonGlyph: <Glyphs.CaratDown16x16/>,
      testId: 'versions-button',
      closeMenuOnClick: true
   };

   return (
      <React.Fragment>
         <div className="versions-button">
            <PopoverButton
               buttonText={Strings.labels.versions.versionFullDropDown.replace('{param0}', currentVersionNumber.toString())}
               {...popoverProps}/>
         </div>
         <div className="mobile-versions-button">
            <PopoverButton
               buttonText={'V' + currentVersionNumber.toString()}
               {...popoverProps}/>
         </div>
      </React.Fragment>
   );
};

export interface VersionsButtonProps extends Themeable {
   currentVersionNumber: number;
   deleteVersion(version: ReviewVersionModel): void;
}
